import { uploadApi } from '../api/userProfileManager';
export default async (avatar, hashCode, logger) => {
    const res = await uploadApi('put', { avatar }, `profile/{userId}/avatar`, {
        'If-Match': hashCode,
    }, logger);
    return {
        hashCode: res.headers.get('etag')?.replace(/"/g, ''),
    };
};
